import fetchWithTimeout from "../../utils/fetchWithTimeout";
import PubSub from "../../utils/PubSub";

export function removeFromFavorites(formData) {
  const productId = formData.get("product_id");

  return fetchWithTimeout(
    favoritesVars.ajaxUrl,
    {
      method: "POST",
      headers: { "Content-Type": "application/x-www-form-urlencoded" },
      body: new URLSearchParams({
        action: "remove_from_favorites",
        product_id: productId,
        nonce: favoritesVars.nonce,
      }).toString(),
    },
    5000,
    "removeFromFavorites"
  ).then((response) => {
    // After successful removal, publish a global event with the product ID
    if (response.success) {
      PubSub.publish("favorites:itemRemoved", { productId });
    }
    return response;
  });
}
